export default {
  SET_AUTHENTICATED: 'SET_AUTHENTICATED',
  CHECK_CURRENT_USER_REQUEST: 'CHECK_CURRENT_USER_REQUEST',
  SET_USER_IS_VALID: 'SET_USER_IS_VALID',
  SET_USER_IS_VALID_FLAG: 'SET_USER_IS_VALID_FLAG',
  SET_USER_IS_INVALID: 'SET_USER_IS_INVALID',
  LOGOUT: 'LOGOUT',
  SET_USER: 'SET_USER',
};
